import React, { Component } from "react";
import Contents from "./Contents";
import { ContentsProvider } from "./context/contents.contexts";
class ContentsWrapper extends Component {
  render() {
    return (
      <ContentsProvider>
        <div className="table-container">
          <Contents />
        </div>
      </ContentsProvider>
    );
  }
}

export default ContentsWrapper;
